// Batida disco/flashback gerada no navegador (Web Audio), sem arquivo e sem
// direitos autorais. Usada quando /audio/flashback.mp3 não existe.
// 120 BPM, bumbo em todo tempo, chimbal no contratempo, palma no 2 e 4,
// baixo em oitavas e acordes curtos (Am – F – C – G).

const BPM = 120;
const STEP = 60 / BPM / 4; // semicolcheia
const LOOKAHEAD = 0.1;
const TICK_MS = 25;

const CHORDS = [
  [57, 60, 64], // Am
  [53, 57, 60], // F
  [48, 52, 55], // C
  [55, 59, 62], // G
];
const hz = (midi) => 440 * 2 ** ((midi - 69) / 12);

export const createDiscoSynth = () => {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const master = ctx.createGain();
  master.gain.value = 0;
  master.connect(ctx.destination);

  const noise = ctx.createBuffer(1, ctx.sampleRate, ctx.sampleRate);
  const data = noise.getChannelData(0);
  for (let i = 0; i < data.length; i += 1) data[i] = Math.random() * 2 - 1;

  const env = (t, peak, decay) => {
    const g = ctx.createGain();
    g.gain.setValueAtTime(peak, t);
    g.gain.exponentialRampToValueAtTime(0.001, t + decay);
    g.connect(master);
    return g;
  };

  const kick = (t) => {
    const o = ctx.createOscillator();
    o.frequency.setValueAtTime(140, t);
    o.frequency.exponentialRampToValueAtTime(45, t + 0.12);
    o.connect(env(t, 0.9, 0.3));
    o.start(t);
    o.stop(t + 0.3);
  };

  const noiseHit = (t, freq, peak, decay) => {
    const src = ctx.createBufferSource();
    src.buffer = noise;
    const f = ctx.createBiquadFilter();
    f.type = 'highpass';
    f.frequency.value = freq;
    src.connect(f).connect(env(t, peak, decay));
    src.start(t);
    src.stop(t + decay);
  };

  const tone = (t, freq, type, peak, decay, cutoff) => {
    const o = ctx.createOscillator();
    o.type = type;
    o.frequency.value = freq;
    const f = ctx.createBiquadFilter();
    f.type = 'lowpass';
    f.frequency.value = cutoff;
    o.connect(f).connect(env(t, peak, decay));
    o.start(t);
    o.stop(t + decay);
  };

  let step = 0;
  let nextTime = 0;
  let timer = null;

  const schedule = (t, s) => {
    const beatStep = s % 16;
    const chord = CHORDS[Math.floor(s / 16) % CHORDS.length];
    if (beatStep % 4 === 0) kick(t);
    if (beatStep % 4 === 2) noiseHit(t, 7000, 0.18, 0.12);
    if (beatStep === 4 || beatStep === 12) noiseHit(t, 1500, 0.35, 0.18);
    if (beatStep % 2 === 0) tone(t, hz(chord[0] - 24 + (beatStep % 4 === 2 ? 12 : 0)), 'sawtooth', 0.22, 0.18, 900);
    if (beatStep === 2 || beatStep === 7 || beatStep === 10) chord.forEach((n) => tone(t, hz(n), 'square', 0.05, 0.16, 2400));
  };

  const tick = () => {
    while (nextTime < ctx.currentTime + LOOKAHEAD) {
      schedule(nextTime, step);
      nextTime += STEP;
      step += 1;
    }
  };

  return {
    async start() {
      await ctx.resume();
      nextTime = ctx.currentTime + 0.05;
      master.gain.cancelScheduledValues(ctx.currentTime);
      master.gain.setTargetAtTime(0.35, ctx.currentTime, 0.4);
      if (!timer) timer = setInterval(tick, TICK_MS);
    },
    stop() {
      master.gain.cancelScheduledValues(ctx.currentTime);
      master.gain.setTargetAtTime(0, ctx.currentTime, 0.15);
      clearInterval(timer);
      timer = null;
    },
    close() {
      clearInterval(timer);
      ctx.close();
    },
  };
};
